module.exports = __webpack_public_path__ + "img/logo.10e8c726.png";